import type { AppConfig } from '#/config/types/AppConfig';
import { imageUrl } from '#/utils/filestack';

type Args = {
  handle: string;
  mimetype: string | undefined;
  ratio: number;
  width: number;
  height: number;
  appConfig: AppConfig;
};

export function headerImageUrl({
  handle,
  mimetype,
  ratio,
  width,
  height,
  appConfig,
}: Args) {
  return imageUrl({
    data: { handle, mimetype },
    width: width * ratio,
    height: height * ratio,
    fit: 'crop',
    insecureSVG: true,
    appConfig,
  });
}
